import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

class PasswordEyeInitializer extends Component {
    componentDidMount() {
        this.addEyeIcons();
    }

    componentDidUpdate(prevProps) {
        // Controlla se il path è cambiato
        if (this.props.location.pathname !== prevProps.location.pathname) {
            this.addEyeIcons();
        }
    }

    addEyeIcons() {
        const passwordFields = document.querySelectorAll('input[type="password"]');

        passwordFields.forEach((field) => {
            if (field.dataset.eyeAttached === 'true') return;

            const wrapper = document.createElement('div');
            wrapper.style.position = 'relative';
            wrapper.style.display = 'inline-block';
            wrapper.style.width = '100%';

            field.style.width = '100%';
            field.parentNode.insertBefore(wrapper, field);
            wrapper.appendChild(field);

            const eye = document.createElement('i');
            eye.classList.add('bi', 'bi-eye');
            eye.style.position = 'absolute';
            eye.style.right = '10px';
            eye.style.top = '55%';
            eye.style.transform = 'translateY(-50%)';
            eye.style.cursor = 'pointer';
            eye.style.color = '#555';
            eye.style.fontSize = '1.3em';
            wrapper.appendChild(eye);

            const showPassword = () => {
                field.type = 'text';
                eye.classList.remove('bi-eye');
                eye.classList.add('bi-eye-slash');
            };

            const hidePassword = () => {
                field.type = 'password';
                eye.classList.remove('bi-eye-slash');
                eye.classList.add('bi-eye');
            };

            eye.addEventListener('mousedown', showPassword);
            eye.addEventListener('mouseup', hidePassword);
            eye.addEventListener('mouseleave', hidePassword);
            eye.addEventListener('touchstart', showPassword);
            eye.addEventListener('touchend', hidePassword);

            field.dataset.eyeAttached = 'true';
        });
    }

    render() {
        return null;
    }
}

export default withRouter(PasswordEyeInitializer);
